import { Component } from "@angular/core";
import { UserCanService } from "../../services/user-can.service";

@Component({
    selector: "app-terminal",
    standalone: false,
    templateUrl: "./terminal.component.html",
    styleUrls: ["./terminal.component.scss", "../../style/sidebarLayout.scss"],
})
export class TerminalComponent {
    constructor(public readonly userCan: UserCanService) {}
}